import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        this.handleDocumentClick = this.handleDocumentClick.bind(this);

        const navToggle = this.element;
        if (navToggle) {
            navToggle.addEventListener("click", (e) => {
                navToggle.classList.toggle("open");
                document.querySelector("nav").classList.toggle("active");
                e.preventDefault();
            });

            document.addEventListener("click", this.handleDocumentClick);
        }
    }

    disconnect() {
        document.removeEventListener("click", this.handleDocumentClick);
    }

    handleDocumentClick(e) {
        const nav = document.querySelector("nav");
        const navToggle = this.element;

        if (!nav || !navToggle.classList.contains("open")) return;

        // If the click is outside both the toggle and the nav
        if (!nav.contains(e.target) && !navToggle.contains(e.target)) {
            nav.classList.remove("active");
            navToggle.classList.remove("open");
        }
    }
}
